/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TournamentGroupStanding = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
        standings: {
            type: 'array',
            contains: {
                type: 'TournamentStanding',
            },
            isRequired: true,
        },
    },
} as const;
